/**
 * TanStack Query Client Configuration
 * 
 * Provides global caching, background revalidation, and optimistic updates
 * for the entire application. Configured for a "zero-latency" feel with
 * stale-while-revalidate pattern.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data considered fresh for 30 seconds - won't refetch during this time
      staleTime: 30 * 1000,
      
      // Cache retained for 5 minutes after last subscriber unmounts
      gcTime: 5 * 60 * 1000,
      
      // Prevent aggressive refetching on window focus (mobile-friendly)
      refetchOnWindowFocus: false,
      
      // Only retry once on failure
      retry: 1,
      
      // Don't refetch on reconnect by default (handled manually where needed)
      refetchOnReconnect: false,
    },
    mutations: {
      // Retry mutations once on network errors
      retry: 1,
    },
  },
});

/**
 * Query Keys Factory
 * Centralized query key management for type safety and consistency
 */
export const queryKeys = {
  favorites: {
    all: ['favorites'] as const,
    byUser: (userId: string) => ['favorites', userId] as const,
  },
  // Add more query keys here as needed
} as const;
